module.exports = __webpack_public_path__ + "static/media/preview-3.443099b4.jpg";